import {Store, createStore} from 'vuex';
import WaypointDialogModule, {WaypointDialogState} from "../../waypoint_dialog/store/module/WaypointOptionsDialogModule";
import AmenityAppModule, {AmenityAppState} from "./modules/AmenityAppModule";
import BaseMapDataPOIsModule, {BaseMapDataPOIsState} from "../../base_map_dialog/store/modules/BaseMapDataPOIsModule";

declare global {
  interface Window {
    map: mapboxgl.Map;
    trailCenterX: string;
    trailCenterY: string;
  }
}

export interface RootState {
  mapDataPOIs: BaseMapDataPOIsState,
  waypoints: WaypointDialogState,
  amenities: AmenityAppState
}

const store: Store<RootState> = createStore({
  modules: {
    mapDataPOIs: BaseMapDataPOIsModule,
    waypoints: WaypointDialogModule,
    amenities: new AmenityAppModule(),
  }
})

export default store;
